import { render, staticRenderFns } from "./VersionBuyCount.vue?vue&type=template&id=617e0e59&scoped=true"
import script from "./VersionBuyCount.vue?vue&type=script&lang=js"
export * from "./VersionBuyCount.vue?vue&type=script&lang=js"
import style0 from "./VersionBuyCount.vue?vue&type=style&index=0&id=617e0e59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617e0e59",
  null
  
)

export default component.exports